import { render, staticRenderFns } from "./SellableServiceEditor.vue?vue&type=template&id=053896bc"
import script from "./SellableServiceEditor.vue?vue&type=script&lang=ts"
export * from "./SellableServiceEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports